/**
 * @GENERATED from Figma node 3638:52291
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const UnknownDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#978F86"
      fillRule="evenodd"
      d="M17.622 9.21C17.532 5.832 15.69 4.188 12 4.188S6.469 5.832 6.379 9.212C3.736 9.886 2 11.023 2 12.312c0 1.05 1.148 1.997 2.998 2.678l-1.346 2.86 1.696.8 1.472-3.13c1.26.287 2.7.473 4.243.526v3.767h1.874v-3.767a23 23 0 0 0 4.19-.513l1.516 3.41 1.714-.761-1.41-3.172C20.829 14.328 22 13.37 22 12.313c0-1.29-1.736-2.427-4.378-3.102m-8.57-2.347c-.425.4-.802 1.14-.802 2.613v.416a9.7 9.7 0 0 0 7.5 0v-.416c0-1.474-.377-2.213-.802-2.613-.449-.421-1.304-.8-2.948-.8s-2.5.379-2.948.8"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(UnknownDark);
export { ForwardRef as UnknownDark };
